export class IncentiveFundAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** A market's envelopes (and its country's), the policy state and the recent investments (`incentive_fund:view`). */
    balances(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/incentive-fund/balances?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /** Propose an owner deposit (the maker, `incentive_fund:invest`); `409 FUND_POLICY_UNSET` while the market publishes no policy. */
    proposeInvestment(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/incentive-fund/investments', body: input, auth: true });
    }
    /** The checker (never the proposer, `incentive_fund:approve`) applies or rejects; `403 FUND_SELF_APPROVAL` for the proposer. */
    decideInvestment(investmentId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/incentive-fund/investments/${encodeURIComponent(investmentId)}/decision`, body: input, auth: true });
    }
}
//# sourceMappingURL=incentive-fund.js.map